const LegalFooterLogin = () => {
  return (
    <div className="legal-footer">
      <p>
        By using Manta Classic, you accept the{" "}
        <a href="https://manta.app/legal/terms-of-use" target="_blank">
          Terms of Use
        </a>{" "}
        and{" "}
        <a href="https://manta.app/legal/privacy" target="_blank">
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default LegalFooterLogin;
